// Public Web3Forms access key (domain-restrict in Web3Forms dashboard).
// Override via REACT_APP_WEB3FORMS_ACCESS_KEY in .env for other environments.
export const WEB3FORMS_ACCESS_KEY =
  process.env.REACT_APP_WEB3FORMS_ACCESS_KEY ||
  "0124d129-b228-4a8f-ae03-77c5b61b30dd";
